import type {
  IDeleteMediaResponse,
  IUpdatedWithPlaceholder,
} from "../../features/gallery/state/gallerySlice";
import { fetchMediasByIds } from "../../features/gallery/state/gallerySlice";
import { updateProjectGroupThumbnail } from "../../features/projectGroups/state/projectGroupsSlice";
import { updateProjectThumbnail } from "../../features/projects/state/projectsSlice";
import type { IMedia } from "../../model/unityObject";
import type { AppDispatch } from "../state/store";

export const handleMediaPlaceholderRefreshAfterDeletion = async ({
  payload,
  dispatch,
}: {
  payload: IDeleteMediaResponse;
  dispatch: AppDispatch;
}) => {
  /* update the relevant stores so its seemless for the users. we need to handle:
      - project_group.source_thumbnail v
      - project.source_thumbnail  v
      - all node edition (in graph)
      - organization.source_logo
      - user.source_avatar
  */

  const newMediaIds = Array.from(
    new Set(
      payload.updatedWithPlaceholders
        .map((updated) => Number(updated.newMediaId))
        .filter((id) => Number.isFinite(id)),
    ),
  );

  const mediaById = new Map<number, IMedia>();
  if (newMediaIds.length > 0) {
    const result = await dispatch(fetchMediasByIds(newMediaIds)).unwrap();
    result.results.forEach((m) => mediaById.set(Number(m.id), m));
  }

  payload.updatedWithPlaceholders.forEach((updated: IUpdatedWithPlaceholder) => {
    const placeholderMediaObject = mediaById.get(Number(updated.newMediaId)) as IMedia;

    if (updated.modelName === "project-group") {
      dispatch(updateProjectGroupThumbnail(placeholderMediaObject));
    }
    if (updated.modelName === "project") {
      dispatch(updateProjectThumbnail(placeholderMediaObject));
    }
    /* since this one is pretty complex to handle, we instead disabled the "suppress media" button in the context of the graph gallery  
		if (updated.modelName.includes("content-")) {
		}
		*/
  });
  return null;
};
